const StatCard: React.FC<{ title: string; value: string | number; icon: React.ReactNode }> = ({ title, value, icon }) => (
    <div className="flex items-center p-4 bg-white dark:bg-gray-800 rounded-lg shadow-sm">
        <div className="flex items-center justify-center p-3 bg-blue-100 dark:bg-blue-900/20 rounded-lg">
            {icon}
        </div>
        <div className="ml-4">
            <p className="text-sm text-gray-500 dark:text-gray-400">{title}</p>
            <p className="text-lg font-semibold text-gray-900 dark:text-white">{value}</p>
        </div>
    </div>
);

export default StatCard;